const pagesOperationEventsEn = {
  list: {
    startNew: "Start New",
    tabs: {
      overview: "Overview",
      events: "Events",
      archive: "Archive",
      operationActivity: "Operation Activity",
      ruleAndPolicy: "Rule & Policy",
      config: "Config",
      settings: "Settings",
    },
  },
  detail: {
    title: "Operation Event",
    anchorDate: "Start Date",
    task: "Task",
    tabs: {
      steps: "Steps",
      manual: "Manual",
      data: "Data",
      operationActivity: "Operation Activity",
    },
  },
  stepFlow: {
    noSteps: "No operation steps available",
  },
  stepDrawer: {
    close: "Close",
    step: "Step",
    fetchError: "Failed to fetch operation step",
    noTasks: "No tasks available",
  },
  filters: {
    status: {
      label: "Status",
      inProgress: "In Progress",
      completed: "Completed",
      aborted: "Aborted",
    },
    pattern: {
      label: "Pattern",
      searchPlaceholder: "Search patterns",
      noResults: "No results found",
    },
    eventType: {
      label: "Event Type",
      searchPlaceholder: "Search event types",
      noResults: "No results found",
    },
  },
  startDialog: {
    title: "Start New",
    startButton: "Start New",
    selectedPattern: "Selected Pattern:",
    eventStarted: "Operation event has started",
    selectEventType: {
      label: "Event Type",
      loading: "Loading...",
    },
    selectPattern: {
      label: "Pattern",
      loading: "Loading...",
    },
    selectTarget: {
      label: "Target",
      searchPlaceholder: "Search for target",
      anchorDate: "Anchor Date",
      selectedCount: "Selected: {{count}}",
    },
  },
  table: {
    headers: {
      event: "Event",
      anchorDate: "Anchor Date",
      stepProgress: "Step Progress",
      taskProgress: "Task Progress",
      status: "Status",
    },
    instanceCount: "{{count}} instances",
    expand: "Expand",
    collapse: "Collapse",
    actions: {
      details: "Details",
    },
  },
};

export default pagesOperationEventsEn;
